import { render, staticRenderFns } from "./InternetTradingPolicy.vue?vue&type=template&id=b846621c&scoped=true&lang=pug"
import script from "./InternetTradingPolicy.vue?vue&type=script&lang=ts"
export * from "./InternetTradingPolicy.vue?vue&type=script&lang=ts"
import style0 from "./InternetTradingPolicy.vue?vue&type=style&index=0&id=b846621c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b846621c",
  null
  
)

export default component.exports